import React, { useEffect, useRef } from "react";
import { useState } from "react";
import UploadButton from "../UploadButton/UploadButton";
import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { useOnClickOutside } from "../../CustomHooks/useOnClickOutside";
import { currencyApiParams, currencyApiParamsValue } from "../../helpers/helper";
import {
  fetchProfileCurrency,
  postUserMenu,
  profile_selected_currency,
  fx_currency_data,
  update_current_currency,
} from "../../Redux/features/Dashboard/DashBoardSlice";
import { Link } from "react-router-dom";
import ArrowIcon from "../Icons/ArrowIcon";
import Svg from "../Svg/Svg";
import {
  addLayoutToUserLayouts,
  addUserGirdLayout,
  updateScreenLock,
  update_grid_error_message,
  update_main_user_grid,
} from "../../Redux/features/MainDashboard/MainDashBoardSlice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DropdownItem from "./ChildMenubar";
type Props = {};

/**
 * Menubar component representing the top menu bar with dropdown items.
 *
 * @param {Props} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered menu bar.
 */
const Menubar = (props: Props): JSX.Element => {
  const [data, setData] = useState(false);
  const [dataGrid, setDataGrid] = useState(false);
  const [dataCurrency, setCurrency] = useState(false);
  const menuData = useAppSelector((state) => state.dashBoard.menuData);
  // const fxCurrencyArray: any = useAppSelector(fx_currency_data);
  const fxCurrencyArray: any = useAppSelector((state) => state.dashBoard.fx_currency_data);
  const selected_currency = useAppSelector((state) => state.dashBoard?.fx_currency_data?.selected_currency);
  const currencyValue = Object.keys(fxCurrencyArray?.currencyList);
  const loggedType = useAppSelector((state) => state.mainDashBoard.loggedType);
  // console.log("currencyValue", currencyValue);
  const items = currencyValue;
  const groupSize = 4;
  const groups: any = [];
  for (let i = 0; i < items.length; i += groupSize) {
    const group = items.slice(i, i + groupSize);
    groups.push(group);
  }
  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  const onCurrencyChange = (item: string) => {
    setSelectedItem(item);
    let currencyApiparam = selectedItem;

    // dispatch(fetchProfileCurrency(currencyApiparam));
    dispatch(
      fetchProfileCurrency({
        currency: item,
      })
    );
  };

  const dispatch = useAppDispatch();
  const [isOpened, setIsOpened] = useState<any>(0);
  function toggle(item: any) {
    // setIsOpened((menuId: any) => (item.id === menuId ? 0 : item.id));
    if (item.name !== "Execution") {
      if (item.url !== "") {
        window.location.href = item.url;
      }
    }
  }
  // const userId = useAppSelector((state) => state.dashBoard.is_bulk_upload);
  // console.log("userId",userId);
  // let id = 1;

  const ref: any = useRef(null);
  useOnClickOutside(ref, () => {
    setData(false);
    setDataGrid(false);
    setIsOpened(0);
  });
  // console.log("parentArray",parentArray);
  // console.log("menuData", menuData);
  // ${parentArray[0]?.id === item.id ? "active" : ""}`
  const girdLayout = useAppSelector((state) => state.mainDashBoard.girdLayout);
  const handleOpenItem = () => {};
  const userGrids = useAppSelector((state) => state.mainDashBoard.userGrids);
  const gridErrorMessage = useAppSelector((state) => state.mainDashBoard.gridErrorMessage);
  useEffect(() => {
    if (gridErrorMessage !== "") {
      console.log("INNNN :: ");
      toast.error(gridErrorMessage, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      dispatch(update_grid_error_message({ gridErrorMessage: "" }));
    }

    return () => {
      // this now gets called when the component unmounts
    };
    // eslint-disable-next-line
  }, [gridErrorMessage]);
  const ValidationOptionsArray: Array<{ value: string; label: string }> = [
    { value: "chartGrid", label: "Chart grid already existing in layout" },
    { value: "orderWindow", label: "Order Execution Chart grid already existing in layout" },
    { value: "orderList", label: "Order list grid already existing in layout" },
  ];
  // const [disabledItems, setDisabledItems] = useState([]);
  const [isClickDisabled, setClickDisabled] = useState(false);
  const handleAddNewGrid = (item: any, index: number) => {
    //code for adding new grid and validation
    console.log("userGrids validation type :: ", item);
    console.log("userGrids validation :: ", userGrids);
    if (isClickDisabled) {
      toast.error("Please wait previous event is working!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    setClickDisabled(true);
    // setDisabledItems((prevDisabledItems) => {
    //   const updatedDisabledItems: any = [...prevDisabledItems];
    //   updatedDisabledItems[index] = !updatedDisabledItems[index];
    //   return updatedDisabledItems;
    // });
    var hasOrderGridValue = userGrids.some((gridItem: any) => gridItem.grid_component_slug === item);
    console.log("userGrids validation hasOrderGridValue :: ", hasOrderGridValue);
    if (item === "wishList") {
      hasOrderGridValue = false;
    }
    if (hasOrderGridValue) {
      // fire existing grid message
      const chartGridOption: any = ValidationOptionsArray.find((option) => option.value === item);
      let validationMessage = chartGridOption.label;
      toast.error(validationMessage, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      //add new grid item
      dispatch(addUserGirdLayout(item));
    }
    setTimeout(() => {
      setClickDisabled(false);
    }, 2000);
  };
  useEffect(() => {
    dispatch(postUserMenu());
  }, []);
  const is_screen_lock = useAppSelector((state) => state.mainDashBoard.is_screen_lock);
  const [isSwitchOn, setIsSwitchOn] = useState(is_screen_lock);
  // useEffect(() => {
  //   setIsSwitchOn(is_screen_lock);
  // }, [is_screen_lock]);
  const handleSwitchToggle = () => {
    console.log("isSwitchOn", isSwitchOn);
    dispatch(updateScreenLock(!isSwitchOn));
    setIsSwitchOn(!isSwitchOn);
  };
  return (
    <>
      {menuData.length ? (
        <div className="rounded-t-[20px] border-b border-[#071932] flex w-full  items-center bg-[#f0f1f3]">
          {/* Map over MenuList and render a DropdownItem for each item */}
          {menuData.map((item) => (
            <DropdownItem key={item.id} item={item} />
          ))}
          <div className="current-design-btn flex" ref={ref}>
            <div className={`${data === true ? "open" : ""} p-relative ml-10 upload-btn mt-0 btn-match`}>
              <button
                id="first-element"
                className="dropdown-toggle new-btn-2"
                type="button"
                data-toggle="dropdown"
                onClick={() => {
                  setData((show) => !show);
                  setDataGrid(false);
                }}
              >
                <span className="new-btn-2-span">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      className="innerColor"
                      id="portfolio_blue"
                      fill="#071932"
                      d="M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.2-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.2-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"
                    />
                  </svg>
                </span>
                <div className="tooltiptext tool-right">
                  <p>Settings</p>
                </div>
              </button>
              {data && (
                <ul className="dropdown-menu pull-right sm-wh-100 setting-dropdown-one dropdown-custom-width">
                  <li key={"sw-1"}>
                    <div className="switch-container">
                      <p className="opt-txt">{isSwitchOn ? "Unlock Screen" : "Lock Screen"}</p>
                      {/* <p className="opt-txt">Screen Lock/Unlock</p> */}
                      <label className="switch-label">
                        Switch
                        <input type="checkbox" checked={isSwitchOn} onChange={handleSwitchToggle} className="switch-input" />
                        <span className="switch-slider"></span>
                      </label>
                      {/* <p className="opt-txt">{isSwitchOn ? "" : "Unlock"}</p> */}
                    </div>
                  </li>
                  {/* {loggedType === "internal" && (
                  <li key={"sw-2"}>
                    {groups.map((group: any, groupIndex: any) => (
                      <ul className="multi-option-tab">
                        {group.map((item: any, itemIndex: any) => (
                          <li key={itemIndex + "-" + groupIndex} className={`${selected_currency === item ? "active" : ""}`}>
                            <a key={itemIndex + "-a-" + groupIndex} onClick={() => onCurrencyChange(item)} title={item} className="currency_filter">
                              {fxCurrencyArray.currencyList[item]}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ))}
                  </li>
                )} */}
                  {/* {dataGrid && ( */}
                  {/* <ul className="dropdown-menu pull-right sm-wh-100 setting-dropdown-menu "> */}
                  {girdLayout.map((item: any, index: number) => (
                    <>
                      {(loggedType === "internal"||loggedType === "internal_destributor") ? (
                        <li key={index} className="grid-layout-panel-listitem">
                          <Link to="" title={""} onClick={(e: any) => handleAddNewGrid(item, index)}>
                            {item === "chartGrid" && <>Chart</>}
                            {item === "orderWindow" && <>Execution</>}
                            {item === "orderList" && <>Transactions</>}
                            {item === "wishList" && <>Monitor</>}
                            <svg id="addNew" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path
                                fill="#071932"
                                className="innerColor"
                                d="M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
                              ></path>
                            </svg>
                          </Link>
                        </li>
                      ) : (
                        <>
                          {item === "wishList" && (
                            <li key={index} className="grid-layout-panel-listitem">
                              <Link to="" title={""} onClick={(e: any) => handleAddNewGrid(item, index)}>
                                {item === "wishList" && <>Monitor</>}
                                <svg id="addNew" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                  <path
                                    fill="#071932"
                                    className="innerColor"
                                    d="M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
                                  ></path>
                                </svg>
                              </Link>
                            </li>
                          )}
                        </>
                      )}
                    </>
                  ))}
                  {/* </ul> */}
                  {/* )} */}
                </ul>
              )}
            </div>

            {/* <div className={`${dataGrid === true ? "open" : ""} grid-controll-btn p-relative ml-10 upload-btn mt-0 btn-match`}>
            <button
              id="controll-element"
              className="dropdown-toggle new-btn-2"
              type="button"
              data-toggle="dropdown"
              onClick={() => {
                setDataGrid((show) => !show);
                setData(false);
              }}
            >
              <span className="new-btn-2-span">
                <Svg type="v-dots" />
              </span>
              <div className="tooltiptext tool-right">
                <p>Grid</p>
              </div>
            </button>
            {dataGrid && (
              <ul className="dropdown-menu pull-right sm-wh-100 setting-dropdown-menu ">
                {girdLayout.map((item: any, index: number) => (
                  <li key={index} className="grid-layout-panel-listitem">
                    <Link to="" title={""} onClick={(e: any) => handleAddNewGrid(item, index)}>
                      {item === "chartGrid" && <>Chart</>}
                      {item === "orderWindow" && <>Execution</>}
                      {item === "orderList" && <>Transactions</>}
                      {item === "wishList" && <>Monitor</>}
                      <svg id="addNew" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.78 23.81">
                        <path fill="#071932" className="innerColor" d="M23.78,14.41H14.38v9.4h-4.93V14.41H0v-4.96H9.45V0h4.93V9.45h9.4v4.96Z"></path>
                      </svg>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div> */}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Menubar;
